<template>
  <list-page-layout class="lease-list-page" :pageSize="pageSize" :currentPage="pageIndex" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">维修支出报表</span>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.ItemName" placeholder="请输入物料名称/物料编码" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="批次号">
        <el-input class="form-input" v-model="Search.BatchCode" placeholder="请输入批次号" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="维修类型">
        <el-select class="form-input" v-model="Search.Type" filterable placeholder="请选择或输入维修类型" clearable>
          <el-option label="代管维修" value="代管维修"></el-option>
          <el-option label="拆件维修" value="拆件维修"></el-option>
          <el-option label="委托维修" value="委托维修"></el-option>
          <el-option label="外部维修" value="外部维修"></el-option>
          <el-option label="自维修" value="自维修"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间段">
      <el-date-picker
        v-model="Search.OrderDateDuration"
        type="daterange"
        align="right"
        placeholder="选择日期范围" @keyup.enter.native="handleSearch">
      </el-date-picker>
      </el-form-item>
      <el-form-item label="区域">
        <el-select v-model="Search.Area" class="form-item" filterable placeholder="请选择或输入区域" clearable>
            <el-option
            v-for="item in Area"
            :key="item.Id"
            :label="item.Name"
            :value="item.Name">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" @click="handleSearch" style="width: 120px">查询</el-button>
      </el-form-item>
    </el-form>
  <div class="main-content" slot="main-content">
      <el-row type="flex" justify="end" class="payment">
        <el-col :span="2.5">维修总支出：<span class="status">{{receiptFee | amount}}</span></el-col>
      </el-row>
      <complex-grid v-loading="IsLoading" element-loading-text="加载中" :config="tableConfig" :data="List">
        <template slot="sub-header" scope="props">
          <el-col :span="20">
            <span>{{props.row.CreateOn | date('YYYY-MM-DD HH:mm:ss')}}</span>
            <span style="margin-left: 20px">批次号：{{props.row.BatchCode}}</span>
            <span style="margin-left: 20px">维修类型：{{props.row.Type | RepairType}}</span>
            <span style="margin-left: 20px">维修订单：{{props.row.Code}}</span>
            <span style="margin-left: 20px">维修费用：<span class="status">{{props.row.Fee | amount}}</span></span>
            <span style="margin-left: 20px">已付费用：<span class="status">{{props.row.PaidAmount | amount}}</span></span>
            <span style="margin-left: 20px">区域：{{props.row.Area}}</span>
          </el-col>
        </template>
        <template slot="ProductName" scope="props">
          <p style="margin: 4px 0">{{props.row.ItemName}}</p>
          <p style="margin: 4px 0">物料编码：{{props.row.ItemCode}}</p>
        </template>
        <template slot="CustomerProductName" scope="props">
          <p style="margin: 4px 0">{{props.row.CustomerItemName  | NullShow}}</p>
          <p style="margin: 4px 0">物料编码：{{props.row.CustomerItemCode  | NullShow}}</p>
        </template>
        <template slot="ProductConditionName" scope="props">
          <el-tag :type="props.row.ItemQualityName | ConditionColor">{{props.row.ItemQualityName}}</el-tag>
        </template>
        <template slot="Brand" scope="props">
          <p type="primary">{{props.row.Brand}}</p>
        </template>
        <template slot="Machine" scope="props">
          <p type="primary">{{props.row.Machine}}</p>
        </template>
        <template slot="Module" scope="props">
          <p type="primary">{{props.row.Module}}</p>
        </template>
        <template slot="Quantity" scope="props">
          <p type="primary">{{props.row.Quantity}}</p>
        </template>
        <template slot="action-bar" scope="props">
          <el-button type="text" @click="goto(props.row)">查看</el-button>
        </template>
      </complex-grid>
    </div>
  </list-page-layout>
</template>

<script>
import Countdown from '@/components/common/Countdown'
import ListPageLayout from '@/components/common/ListPageLayout'
import ComplexGrid from '@/components/common/ComplexGrid'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        ItemName: null,
        Type: null,
        OrderDateDuration: null,
        BatchCode: null,
        Area: null,
      },
      IsLoading: false,
      Area: null,
      currentTab: 'all',
      pageSize: 10,
      pageIndex: 1,
      tableConfig: {
        dataPrefix: 'LotList',
        column: [
          {
            label: '物品名称/编码',
            width: '260px',
            slot: 'ProductName',
          },
          {
            label: '客户物料名称/编码',
            slot: 'CustomerProductName',
            width: '260px',
          },
          {
            label: '品项',
            slot: 'ProductConditionName',
            width: '140px',
          },
          {
            label: '品牌',
            slot: 'Brand',
            width: '100px',
          },
          {
            label: '机型',
            slot: 'Machine',
            width: '120px',
          },
          {
            label: '模块',
            slot: 'Module',
            width: '100px',
          },
          {
            label: '数量',
            slot: 'Quantity',
            width: '100px',
          },
          {
            label: '操作',
            collapse: true,
            key: 'action-bar',
            class: 'text-center',
            width: '100px',
          },
        ],
      },
      tableData: [],
      List: [],
      total: 0,
      receiptFee: null,
      listURL: process.env.API_HOST + '/finance/RepairOrder',
    }
  },
  methods: {
    initTotal() {
      o(`Partner/Services.GetCurrentCustomer()`).get().then(({ data }) => {
        let CustomerCode = data.CustomerCode
        let URL = process.env.API_HOST + '/finance/RepairOrder/TotalPaid?code=' + CustomerCode
        this.$http.get(URL).then((response) => {
          this.receiptFee = response.data
        }).catch((response) => {})
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    handleSearch() {
      this.IsLoading = true
      let filters = ''
      if (this.Search.ItemName) {
        filters += '&input.material=' + this.Search.ItemName
      }
      if (this.Search.Source) {
        filters += '&input.source=' + this.Search.Source
      }
      if (this.Search.BatchCode) {
        filters += '&input.batchCode=' + this.Search.BatchCode
      }
      if (this.Search.Area) {
        filters += '&input.area=' + this.Search.Area
      }
      if (this.Search.Type) {
        filters += '&input.type=' + this.Search.Type
      }
      if (this.Search.OrderDateDuration) {
        if (this.Search.OrderDateDuration[0] === null) {
          this.Search.OrderDateDuration === []
        } else {
          const startDate = this.$moment(this.Search.OrderDateDuration[0]).utc().add(1, 'd').set({hour: 0, minute: 0, second: 0}).format()
          const endDate = this.$moment(this.Search.OrderDateDuration[1]).utc().add(2, 'd').set({hour: 0, minute: 0, second: 0}).add(-1, 's').format()
          filters += '&input.minCreateOn=' + startDate
          filters += '&input.maxCreateOn=' + endDate
        }
      }
      const user = JSON.parse(window.localStorage.getItem('CURRENT_USER'))
      let URL = this.listURL + '?input.customer=' + user.userName + '&input.pageSize=' + this.pageSize + '&input.pageIndex=' + this.pageIndex + filters
      this.$http.get(URL).then((response) => {
        this.IsLoading = false
        const data = response.data
        data.List.forEach(Lists => {
          const LotList = []
          const Lot = {
            ItemCode: Lists.ItemCode,
            ItemName: Lists.ItemName,
            ItemQuality: Lists.ItemQuality,
            ItemQualityName: Lists.ItemQualityName,
            Brand: Lists.Brand,
            Machine: Lists.Machine,
            Module: Lists.Module,
            Quantity: Lists.Quantity,
            ID: Lists.ID,
          }
          LotList.push(Lot)
          Lists.LotList = LotList
        })
        this.tableData = data
        this.List = this.tableData.List
        this.PageSize = this.tableData.PageSize
        this.total = this.tableData.Total
      }).catch((response) => {
        this.IsLoading = false
      })
    },
    /* 跳转至维修订单详情页面 */
    goto(row) {
      o('RepairOrder').expand('Lines($expand=Lot)').filter(`Code eq '${row.Code}'`).first().get().then(({data}) => {
        if (data.Id) {
          // 选中的维修批次Id存入缓存，用于跳转后的选中批次高亮效果
          const selectedRepairLine = data.Lines.find((_) => _.Lot.Code === row.BatchCode)
          window.localStorage.setItem('selectedRepairLine', selectedRepairLine.Id)
          this.$router.push('/repair/' + data.Id)
        } else {
          this.$message.error('出现异常，此订单不存在')
        }
      })
    },
    handleChange(params) {
      console.log(params)
      this.pageIndex = params
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    initRegion() {
      o('Region').get()
      .then((response) => {
        this.Area = response.data
      }).catch((err) => {
        console.log(err)
      })
    },
  },
  components: {
    ListPageLayout,
    ComplexGrid,
    Countdown,
  },
  created() {
    this.handleSearch()
    this.initRegion()
    this.initTotal()
  },
}
</script>

<style lang="less" scoped>
.form-input {
  width: 260px;
}
.green{
  color: green;
}
.status{
  color: red;
}
</style>

<style lang="less">
.lease-list-page .el-tabs__active-bar{
  display: none;
}
.payment{
  padding: 5px;
}
</style>




// WEBPACK FOOTER //
// RepairExpenditure_statement.vue?094ce985